<template>
  <b-card no-body>
    <b-card-body>
      <b-card bg-variant="light">
        <b-form-row>
          <b-col lg="6" sm="12" class="text-left">
            <LgFinderPageUnidadeAdministrativa id="finderDepartamentoSI" @onSelect="handleSelectDepartamento(item)"
              :prefix="prefix + title + ' > '" invalidFeedback="Unidade Administrativa deve ser informada!"
              v-model="form.departamento" :podeApagarDepartamento="isUAResponsavePatrimonio"
              :podeMudarDepartamento="isUAResponsavePatrimonio" />

          </b-col>
          <b-col lg="3" sm="9" class="text-left">
            <lg-form-select v-model="form.status" :loadFunction="statusList" labelFormGroupBind="Status:"
              label="descricao" description=" " filterList="true" @change="load" style="z-index: 1000;" @input="load" />
          </b-col>

          <b-col lg="3" sm="3" class="text-left">
            <b-button id="localizarSolicitacaoInventario" class="ml-3 mr-2 my-2" size="sm" style="height: 20px" pill
              variant="primary" @click="load()">
              <div class="btn-size-alinhamento">
                <b-icon icon="search" /> &nbsp;
              </div>
              <b-tooltip title="Localizar" target="localizarSolicitacaoInventario"></b-tooltip>
            </b-button>

            <b-button v-if="temPrivilegioCadastro()" id="novoSolicitacaoInventario" class="mr-2 my-2" size="sm"
              style="height: 20px" @click="adicionarNovo" pill variant="primary">
              <div class="btn-size-alinhamento">
                <b-icon scale="1" icon="plus" /> &nbsp;
                <b-tooltip title="Adicionar novo..." target="novoSolicitacaoInventario"></b-tooltip>
              </div>

            </b-button>


          </b-col>

          <b-col lg="6" sm="12" class="text-left"></b-col>

          <b-col lg="3" sm="12" class="text-left">
            <lg-form-select v-model="form.tipoSolicitacao" :loadFunction="solicitacaoList"
              labelFormGroupBind="Tipo de Solicitação:" label="descricao" description=" " filterList="true"
              @change="load" style="z-index: 999;" @input="load" />
          </b-col>
        </b-form-row>
      </b-card>
      <b-card bg-variant="light" style="z-index: 0;">
        <b-table responsive class="mt-2" small :busy="this.busy" :items="this.records" :fields="this.tableFields"
          :hover="true" show-empty>
          <template #empty>
            <p>Nenhum registro encontrado</p>
          </template>

          <template #table-busy>
            <div class="text-center text-primary my-2">
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </template>

          <template v-slot:cell(enviar)="row">

            <b-button :disabled="StatusSolicitacaoInventarioIBPEnum.REPROVADO.cod == row.item.status.id"
              v-if="StatusSolicitacaoInventarioIBPEnum.EM_DIGITACAO.cod != row.item.status.id"
              :id="row.index + 'parecer-si'" @click="parecer(row.item)" class="my-2" size="sm" pill variant="primary"
              type="button">
              <b-icon icon="file-earmark-medical" />
              <b-tooltip :target="row.index + 'parecer-si'" title="Parecer..."></b-tooltip>

            </b-button>


            <b-button
              v-if="StatusSolicitacaoInventarioIBPEnum.EM_DIGITACAO.cod == row.item.status.id && temPrivilegioEnviar()"
              :id="row.index + 'enviar-si'" @click="enviarSolicitacao(row.item)" class="my-2" size="sm" pill
              variant="primary" type="button">
              <b-icon icon="envelope-open" />
              <b-tooltip :target="row.index + 'enviar-si'" title="Enviar..."></b-tooltip>

            </b-button>
          </template>

          <template v-slot:cell(edit)="row">
            <b-button
              v-if="StatusSolicitacaoInventarioIBPEnum.EM_DIGITACAO.cod == row.item.status.id && temPrivilegioEditar()"
              :id="row.index + 'edit-button-si'" class="my-2" size="sm" pill variant="primary"
              @click="editar(row.item)">
              <b-icon icon="pencil-square" />
              <b-tooltip :target="row.index + 'edit-button-si'" title="Editar..."></b-tooltip>
            </b-button>

            <b-button
              v-if="!row.item.finalizado && StatusSolicitacaoInventarioIBPEnum.APROVADO.cod == row.item.status.id && temPrivilegioIncluirSolicitacaoInventario()"
              :id="row.index + 'inventario-button-si'" class="my-2" size="sm" pill variant="primary"
              @click="inventario(row.item)">
              <b-icon icon="list-ul" />
              <b-tooltip :target="row.index + 'inventario-button-si'" title="Inventário..."></b-tooltip>
            </b-button>

          </template>

          <template v-slot:cell(remover)="row">
            <b-button
              v-if="StatusSolicitacaoInventarioIBPEnum.EM_DIGITACAO.cod == row.item.status.id && temPrivilegioExcluir()"
              :id="row.index + 'excluir-si'" class="my-2" size="sm" pill variant="primary" @click="remove(row.item)">
              <b-icon icon="trash-fill" />
              <b-tooltip :target="row.index + 'excluir-si'" title="Remover..."></b-tooltip>
            </b-button>
          </template>

        </b-table>
        <b-row style="margin-top: 12px" v-if="records && records.length > 0">
          <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
            <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página {{ page }} de {{
              totalPage }} -
              {{ total }} registros</b-col>
            <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
              <b-form-select size="sm" v-model="perPage" @change="() => this.load()" :options="perPageOptions">
              </b-form-select>
            </b-col>
          </b-col>
          <b-col cols="6">
            <div class="d-flex justify-content-end align-items-end">
              <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page" :per-page="perPage"
                :total-rows="total"></b-pagination>
            </div>
          </b-col>
        </b-row>
      </b-card>
    </b-card-body>

    <SolicitacaoInventarioForm v-if="showModal" @close="cancelar" :prefix="prefix + title + ' > '" :id="id" />
    <SolicitacaoInventarioFormParecer v-if="showModalParecer" @close="cancelar" :prefix="prefix + title + ' > '"
      :id="id" />

    <InventarioItemBemPermanenteForm :auditoria="auditoria" :prefix="prefix + title + ' > '" @refreshList="load"
      @close="fecharModal" :codSolicitacaoInventario="codSolicitacaoInventario" v-if="mostrarFormInventario" />

  </b-card>
</template>

<script>
import LgFinderPageUnidadeAdministrativa from "@/components/Finders/LgFinderPageUnidadeAdministrativa.vue"

import ResourceService from "@/core/api/ResourceService";
import LgFormSelect from "@/core/components/Form/LgFormSelect.vue";
import ConfirmMixin from "@/core/mixins/confirm";
import { FormResourceMixin, ListResourceMixin } from "@/core/mixins/resource";
import moment from "moment";
import StatusSolicitacaoInventarioIBPEnum from '@/core/utils/StatusSolicitacaoInventarioIBPEnum'
import TipoStatusEnum from '@/core/utils/TipoStatusEnum'
import SolicitacaoInventarioFormParecer from "./SolicitacaoInventarioFormParecer.vue";
import SolicitacaoInventarioForm from "./SolicitacaoInventarioForm.vue";
import InventarioItemBemPermanenteForm from "../inventario-item-bem-permanente/InventarioItemBemPermanenteForm.vue";
import verificaPrivilegio from "@/utils/VerificaPrivilegio"
import PrivilegiosEnum from "@/core/utils/PrivilegioEnum"

export default {
  components: {
    LgFinderPageUnidadeAdministrativa,
    LgFormSelect,
    SolicitacaoInventarioForm,
    SolicitacaoInventarioFormParecer,
    InventarioItemBemPermanenteForm
  },

  props: {
    prefix: {
      type: String,
      default: "",
    },

  },
  data() {
    return {
      auditoria: {},
      isUAResponsavePatrimonio: false,
      codSolicitacaoInventario: null,
      mostrarFormInventario: false,
      showModalParecer: false,
      StatusSolicitacaoInventarioIBPEnum,
      title: 'Solicitação de Inventário',
      id: null,
      showModal: false,
      perPage: 10,
      perPageOptions: [10, 25, 50, 100],
      form: {
        empresa: {},
        departamento: {},
        tipoSolicitacao: "",
        status: {},
      },
    };
  },
  mixins: [ConfirmMixin, ListResourceMixin, FormResourceMixin],

  async beforeMount() {
    this.$service = new ResourceService(`/api/solicitacaoinventario`);
    this.$statusService = new ResourceService(
      `/api/status/tipo/${TipoStatusEnum.SOLICITACAO_INVENTARIO.cod}`
    );
    this.$solicitacaoService = new ResourceService(`/api/tiposolicitacao`);

    const brand = JSON.parse(localStorage.getItem("context"));
    this.form.departamento = brand.departamento;
    this.load();


    var { data } = await new ResourceService("/api/configuracoes-sistema/id-responsavel-patrimonio").find();

    this.isUAResponsavePatrimonio = data == this.form.departamento.id;


  },

  watch: {
    page() {
      this.load();
    },
  },

  computed: {
    tableFields() {
      return [
        {
          key: "id",
          label: "Número",
          thStyle: "font-size: 16px; font-weight: 400;",
          tdStyle: "font-size: 13px",
        },

        {
          key: "departamento.descricao",
          label: "Unidade Administrativa",
          thStyle: "font-size: 16px; font-weight: 400;",
          tdStyle: "font-size: 13px",
        },

        {
          key: "dhCriacao",
          label: "Criação",
          formatter: (value) => moment(value).format("DD/MM/YYYY"),
          thStyle: "font-size: 16px; font-weight: 400;",
          tdStyle: "font-size: 13px",
        },

        {
          key: "dataAgendamento",
          formatter: (value) => value ? moment(value).format("DD/MM/YYYY") : "",

          label: "Agendamento",
          thStyle: "font-size: 16px; font-weight: 400;",
          tdStyle: "font-size: 13px",
        },

        {
          key: "pessoa.nome",
          label: "Resp. Criação",
          thStyle: "font-size: 16px; font-weight: 400;",
          tdStyle: "font-size: 13px",
        },

        {
          key: "status.descricao",
          label: "Status",
          thStyle: "font-size: 16px; font-weight: 400;",
          tdStyle: "font-size: 13px",
        },

        {
          key: "enviar",
          label: " ",
          thStyle: "font-size: 16px; font-weight: 400;",
          tdStyle: "font-size: 13px",
          tdClass: "w-1",
        },
        {
          key: "edit",
          label: " ",
          thStyle: "font-size: 16px; font-weight: 400;",
          tdStyle: "font-size: 13px",
          tdClass: "w-1",
        },
        {
          key: "remover",
          label: " ",
          thStyle: "font-size: 16px; font-weight: 400;",
          tdStyle: "font-size: 13px",
          tdClass: "w-1",
        },
      ];
    },
  },

  methods: {
    handleSelectDepartamento(departamento) {
      this.form.departamento = departamento;
      this.load();
    },
    isEditavel(status) {

      return status == StatusSolicitacaoInventarioIBPEnum.EM_DIGITACAO.cod;

    },
    temPrivilegioCadastro() {
      return verificaPrivilegio(PrivilegiosEnum.SOLICITACAO_INVENTARIO_BEM_PERMANENTE_INCLUIR);

    },

    temPrivilegioEnviar() {
      return verificaPrivilegio(PrivilegiosEnum.SOLICITACAO_INVENTARIO_BEM_PERMANENTE_ENVIAR);

    },


    temPrivilegioExcluir() {
      return verificaPrivilegio(PrivilegiosEnum.SOLICITACAO_INVENTARIO_BEM_PERMANENTE_EXCLUIR);

    },


    temPrivilegioEditar() {
      return verificaPrivilegio(PrivilegiosEnum.SOLICITACAO_INVENTARIO_BEM_PERMANENTE_EDITAR);

    },


    temPrivilegioIncluirSolicitacaoInventario() {
      return verificaPrivilegio(PrivilegiosEnum.SOLICITACAO_INVENTARIO_BEM_PERMANENTE_INCLUIR);

    },

    fecharModal() {
      this.mostrarFormInventario = false;
      this.auditoria = {};
      this.load();

    },
    inventario(item) {
      if (item.idAuditoria)
        this.auditoria = { id: item.idAuditoria };
      this.codSolicitacaoInventario = item.id;
      this.mostrarFormInventario = true;


    },
    async remove(item) {
      await this.$removeResource(item);
      this.load();
    },
    parecer(item) {
      this.id = item.id;
      this.showModalParecer = true;
    },


    editar(item) {
      this.id = item.id;
      this.showModal = true;
    },
    adicionarNovo() {
      this.id = null;
      this.showModal = true;

    },
    async enviarSolicitacao(item) {
      await this.$service.put(`enviar/${item.id}`, {});
      this.load();
    },
    cancelar() {
      this.id = null;
      this.showModal = false;
      this.showModalParecer = false;
      this.load();
    },

    async load() {
      this.filtro = {};

      if (this.form.departamento && this.form.departamento.id) {
        this.filtro.departamento = this.form.departamento.id;
      }

      if (this.form.tipoSolicitacao && this.form.tipoSolicitacao.id) {
        this.filtro.tipoSolicitacao = this.form.tipoSolicitacao.id;
      }

      if (this.form.status && this.form.status.id) {
        this.filtro.status = this.form.status.id;
      }

      this.busy = true;
      await this.$loadResource({
        size: this.perPage,
        page: this.page,
        params: this.filtro,
      });
    },

    async solicitacaoList({ filter, page = 1 }) {
      return this.$solicitacaoService.findAll({ filter, page, limit: 5 });
    },

    async statusList({ filter, page = 1 }) {
      return this.$statusService.findAll({ filter, page, limit: 5 });
    },
  },
};
</script>